<template lang="html">

    <section class="all-user-list">
        <v-content>
            <v-row v-if="users">

                <v-col cols="2" v-bind:key="user.name" v-for="user in users" align="center">
                    <router-link :to="{ name: 'user', params: { id: user.id }}">
                        <v-avatar size="100" v-if="user.picture_path" class="avatar">
                            <img :src="img_url + user.picture_path" alt="Profilbild"/>
                        </v-avatar>
                        <v-avatar size="100" v-else class="avatar ">
<!--                            {{user.shortName}}-->
                            <v-icon class="avatar_default">mdi-account</v-icon>
                        </v-avatar>
                        <h3 style="text-align: center">{{user.name}}</h3>

                    </router-link>
                </v-col>

            </v-row>
        </v-content>
    </section>

</template>

<script lang="js">

    export default {
        name: 'all-user-list',
        props: [],
        mounted() {
            this.users = this.$route.params.users;
            console.log(this.users);
        },
        data() {
            return {
                'users': [],
                'img_url': window.api_url + "/storage/image/user/",
            }
        },
        methods: {},
        computed: {}
    }


</script>

<style scoped lang="scss">
    .all-user-list {

    }
</style>
